<template>
  <el-drawer
  :title="$t('sales_orders.filters.filters')"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form>
      <el-form-item>
        <el-button @click="resetFilters()" size="mini">{{ $t('sales_orders.filters.reset') }}</el-button>
      </el-form-item>
      <el-collapse v-model="activeName">
        <el-collapse-item :title="$t('sales_orders.filters.origin')" name="0">
          <el-checkbox-group v-model="originFilter">
            <el-row :gutter="20">
              <el-col>
                <el-checkbox label="B2B">{{$t('sales_orders.origin.b2b')}}</el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col>
                <el-checkbox label="EXTERNAL">{{$t('sales_orders.origin.external')}}</el-checkbox>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col>
                <el-checkbox label="PORTAUS">{{$t('sales_orders.origin.internal')}}</el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </el-collapse-item>
        <el-collapse-item :title="$t('sales_orders.filters.status')" name="1">
          <el-checkbox-group v-model="statusFilter">
            <el-row :gutter="20" v-for="status in salesOrderStatuses" :key="status.id">
              <el-col>
                <el-checkbox :label="status.id">{{$t('sales_orders.statuses.'+status.code)}}</el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </el-collapse-item>
        <el-collapse-item title="Date" name="1.1">
          <el-form-item :label="$t('sales_orders.sorting.salesDate')">
            <el-date-picker
               v-model="dateFilter"
               type="daterange"
               range-separator="à"
               :start-placeholder="$t('common.startDate')"
               :end-placeholder="$t('common.endDate')">
             </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('sales_orders.deliveryDate')">
            <el-date-picker
               v-model="deliveryDateFilter"
               type="daterange"
               range-separator="à"
               :start-placeholder="$t('common.startDate')"
               :end-placeholder="$t('common.endDate')">
             </el-date-picker>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('sales_orders.filters.inventories')" name="1.5" v-if="isMultipleInventorySystem">
          <el-form-item >
            <selectInventory :selectedInventories="filters.inventories" :multiple="true" @selected="setInventoryFilter"></selectInventory>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('sales_orders.filters.rep')" name="2">
          <el-form-item>
            <el-checkbox-group  v-model="checkedReps" :disabled="repFilterDisabled">
              <el-row :gutter="20" v-for="rep in filterUserWithRoleRep" :key="rep.id" >
                <el-col>
                  <el-checkbox :label="rep.id">{{rep.firstName}} {{rep.lastName}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
            <el-checkbox v-model="withoutReps"  :disabled="repFilterDisabled">Non représenté</el-checkbox>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('clients.filterDialog.customerClass')" name="3">
          <el-checkbox-group  v-model="checkedCustomerClasses" >
            <el-row :gutter="20" v-for="cclass in customerClasses" :key="cclass.id">
              <el-col>
                  <el-checkbox  :label="cclass.id">{{cclass.code}}</el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </el-collapse-item>
        <el-collapse-item :title="$t('common.customer')" name="4">
          <el-form-item >
            <selectCustomer :selectedCustomer="filters.customerId" @selected="setCustomerFilter"></selectCustomer>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('common.product')" name="5">
          <el-form-item >
            <selectProduct :selectedProduct="filters.productId" @selected="setProductFilter"></selectProduct>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('sales_orders.deliveryType')" name="6">
          <el-form-item >
            <selectDeliveryType :deliveryType="filters.deliveryType" @selected="setDeliveryTypeFilter"></selectDeliveryType>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('products.tags')" name="7">
          <el-checkbox-group  v-model="checkedTags" >
            <el-row :gutter="20" v-for="t in listTags"  :key="t.id">
              <el-col>
                  <el-checkbox :label="t.id"  style="margin-left:0px;">{{t.code}}</el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </el-collapse-item>
      </el-collapse>

   </el-form>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';
import selectProduct from '@/components/product/select-product'
import selectCustomer from '@/components/customer/select-customer'
import selectDeliveryType from '@/components/select-delivery-type'
import selectInventory from '@/components/inventory/select-inventory'

export default {
  name: 'sales-order-filter',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      activeName : null,
    };
  },components: {
    selectCustomer,
    selectProduct,
    selectDeliveryType,
    selectInventory
  },
  watch : {

  },
	methods: {
    open(){
      this.fetchCustomerClasses();
      this.fetchTags();
      this.fetchAdminUsers();
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('statuses',['fetchSalesOrderStatuses']),
    ...mapActions('salesOrders', ['setStatusFilters','setOriginFilters', 'resetFilters','setDateFilters', 'setDeliveryDateFilters','changeCustomerClassFilter','setCheckedTagsFilter','setCheckedReps','setFilterWithoutReps', 'setCustomerFilter','setProductFilter','setDeliveryTypeFilter','setInventoryFilter']),
    ...mapActions('controlData',['fetchCustomerClasses']),
    ...mapActions('salesOrderEditor', ['fetchTags']),
    ...mapActions('users',['fetchAdminUsers'])
	},
	computed: {
    repFilterDisabled(){
      return this.isStrictFilteredByRep && this.isCurrentUserRep && !this.isCurrentUserAdmin;
    },
    dateFilter : {
      get(){return this.filters.date},
      set(dateFilter){this.setDateFilters(dateFilter)}
    },
    deliveryDateFilter : {
      get(){return this.filters.deliveryDate},
      set(deliveryDateFilter){this.setDeliveryDateFilters(deliveryDateFilter)}
    },
    statusFilter : {
      get(){return this.filters.status;},
      set(statusFilters){this.setStatusFilters(statusFilters)}
    },
    originFilter : {
      get(){return this.filters.origin;},
      set(originFilters){this.setOriginFilters(originFilters)}
    },
    dateFilter : {
      get(){return this.filters.date},
      set(dateFilter){this.setDateFilters(dateFilter)}
    },
		checkedCustomerClasses :{
			set(val){this.changeCustomerClassFilter(val)},
			get(){return this.filters.checkedCustomerClasses;}
		},
    checkedTags : {
      set(checkedTags){this.setCheckedTagsFilter(checkedTags)},
      get(){return this.filters.checkedTags;}
    },
    checkedReps : {
			set(val){this.setCheckedReps(val)},
			get(){return this.filters.checkedReps}
		},
    withoutReps : {
      set(val){this.setFilterWithoutReps(val)},
      get(){return this.filters.withoutReps}
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
    ...mapState('statuses',['salesOrderStatuses']),
    ...mapState('salesOrders',['filters']),
    ...mapState('controlData',['customerClasses']),
    ...mapState('salesOrderEditor',['listTags']),
    ...mapGetters('users',['filterUserWithRoleRep']),
    ...mapGetters('inventory',['isMultipleInventorySystem']),
    ...mapGetters(['isStrictFilteredByRep', 'isCurrentUserRep', 'isCurrentUserAdmin']),
	},
  created(){
    this.fetchSalesOrderStatuses();
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

// .el-row {
//     margin-bottom: 20px;
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
